import { isNaN } from 'lodash'
import { InputHTMLAttributes, ReactElement, useState } from 'react'
import { IMask } from 'react-imask'

import { MaskInput } from 'components/MaskInput'
import { convertHour12ToHour24Time, convertHour24ToHour12Time } from 'utils/time'

interface IInputTimeProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value: string
  onChange: (value: string) => void
  touched?: boolean
  errors?: string
  optional?: boolean
}

export const InputTime = ({ value, onChange, ...props }: IInputTimeProps): ReactElement => {
  const [inputValue, setInputValue] = useState(convertHour24ToHour12Time(value))

  const handleInputChange = (value: string): void => {
    if (!(props.disabled || props.readOnly)) {
      const lowerCaseValue = value.toLowerCase()
      setInputValue(lowerCaseValue)
      onChange(convertHour12ToHour24Time(lowerCaseValue))
    }
  }

  return (
    <MaskInput
      lazy={isNaN(parseInt(inputValue))}
      id={props.id}
      placeholder="--:-- --"
      mask="hh:mm h12m"
      blocks={{
        hh: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 12,
          maxLength: 2
        },
        mm: {
          mask: IMask.MaskedRange,
          from: 0,
          to: 59,
          maxLength: 2
        },
        h12: {
          mask: IMask.MaskedEnum,
          enum: ['a', 'A', 'p', 'P']
        }
      }}
      placeholderChar="-"
      value={inputValue}
      onAccept={handleInputChange}
      onChange={(): undefined => undefined}
      {...props}
    />
  )
}
